// @flow

import { AxiosPromise } from "axios";
import { bubaClientV2 } from "buba-components/src/api";
import { authenticate as buildAuthenticate, enhance } from "buba-components/src/api/enhancers";
import endpoints from "./endpoints";
import { store } from "../store";

const authenticate = buildAuthenticate(store);

export const downloadGuaranteeRequestDocuments = async (
  financingProcessId: string
): Promise<AxiosPromise<any>> =>
  bubaClientV2(
    enhance(authenticate)({
      method: "get",
      url: endpoints.downloadGuaranteeRequestPdf(financingProcessId),
      responseType: "blob"
    })
  );

export default downloadGuaranteeRequestDocuments;
